import BgImg from '~/assets/holiday/christmas/menu/bg.png';
import { BaseMenu } from './BaseMenu';

export const ChristmasMenu = () => (
  <BaseMenu
    config={{
      containerBgClass: 'bg-cover bg-top bg-no-repeat',
      containerStyle: { 'background-image': `url(${BgImg})` },
      collapseButtonZIndex: true,
      activeColor: '#4267D2',
      tooltipBgColor: '#4267D2',
      linkTooltipBgColor: '#BC4150',
    }}
  />
);
